import { __exports as S } from "./index184.js";
import "./index183.js";
import { __exports as M } from "./index185.js";
Object.defineProperty(S, "__esModule", { value: !0 });
S.default = L;
var b = M, f = "html", v = "head", n = "body", T = /<([a-zA-Z]+[0-9]?)/, h = /<head[^]*>/i, y = /<body[^]*>/i, i = function(e, t) {
  throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
}, d = function(e, t) {
  throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
}, w = typeof window == "object" && window.DOMParser;
if (typeof w == "function") {
  var q = new w(), H = "text/html";
  d = function(e, t) {
    return t && (e = "<".concat(t, ">").concat(e, "</").concat(t, ">")), q.parseFromString(e, H);
  }, i = d;
}
if (typeof document == "object" && document.implementation) {
  var c = document.implementation.createHTMLDocument();
  i = function(e, t) {
    if (t) {
      var o = c.documentElement.querySelector(t);
      return o && (o.innerHTML = e), c;
    }
    return c.documentElement.innerHTML = e, c;
  };
}
var a = typeof document == "object" && document.createElement("template"), m;
a && a.content && (m = function(e) {
  return a.innerHTML = e, a.content.childNodes;
});
function L(e) {
  var t, o;
  e = (0, b.escapeSpecialCharacters)(e);
  var u = e.match(T), s = u && u[1] ? u[1].toLowerCase() : "";
  switch (s) {
    case f: {
      var l = d(e);
      if (!h.test(e)) {
        var r = l.querySelector(v);
        (t = r == null ? void 0 : r.parentNode) === null || t === void 0 || t.removeChild(r);
      }
      if (!y.test(e)) {
        var r = l.querySelector(n);
        (o = r == null ? void 0 : r.parentNode) === null || o === void 0 || o.removeChild(r);
      }
      return l.querySelectorAll(f);
    }
    case v:
    case n: {
      var p = i(e).querySelectorAll(s);
      return y.test(e) && h.test(e) ? p[0].parentNode.childNodes : p;
    }
    default: {
      if (m)
        return m(e);
      var r = i(e, n).querySelector(n);
      return r.childNodes;
    }
  }
}
